import axios from 'axios';

// @todo set this up when sitecote apis are accessible
// get label content
export function getLabelData() {
    const wrapper = document.querySelector('#trialFormWrapper'),
    guid = wrapper ? wrapper.dataset.trialSetting : '';
    return axios.get(`/api/commerce/trial/${guid}`);
}

// post trial data
export function postTrial(data) {
    // get states
    return axios.post(`/api/commerce/trial`, data);
}

// abandonment data
export function abandonnmentEmail(data) {
    return axios.post(`/api/commerce/abandonedcart`, data);
}

